module.exports = __webpack_public_path__ + "img/hzhs5.c1c4019f.jpg";